module.exports = __webpack_public_path__ + "img/EOTP_Skier.396ce0fb.png";